import {types} from "mobx-state-tree";

export const RegionModel = types.model( "RegionModel", {
    value: types.identifier, label: types.string
} );